import { lazy } from 'react';
import { RequestTypeCodes } from '@Enum/index';
import { FormComponent } from './types';

const LeaveRequestApproveForm = lazy(
  () =>
    import(
      '@Features/EmployeeSelfService/requests/LeaveRequest/form/Approve/LeaveRequestApproveForm'
    )
);
const PassportRequestApproveForm = lazy(
  () =>
    import(
      '@Features/EmployeeSelfService/requests/PassportRequest/form/Approve/PassportRequestApproveForm'
    )
);
const SalaryCertificateApproveForm = lazy(
  () =>
    import(
      '@Features/EmployeeSelfService/requests/SalaryCertificate/form/Approve/SalaryCertificateApproveForm'
    )
);
const OverseasMissionApproveForm = lazy(
  () =>
    import(
      '@Features/EmployeeSelfService/requests/OverseasMission/form/Approve/OverseasMissionApproveForm'
    )
);

const ResumptionRequestApproveForm = lazy(
  () =>
    import(
      '@Features/EmployeeSelfService/requests/ResumptionRequests/forms/Approve/ResumptionRequestApprove'
    )
);

const AttendanceRequestApproveForm = lazy(
  () =>
    import(
      '@Features/EmployeeSelfService/requests/AttendanceRequest/form/Approve/AttendanceRequestApproveForm'
    )
);

const approveFormComponents: Record<number, FormComponent> = {
  [RequestTypeCodes.LEAVE_REQUEST]: LeaveRequestApproveForm,
  [RequestTypeCodes.PASSPORT_REQUEST]: PassportRequestApproveForm,
  [RequestTypeCodes.SALARY_CERTIFICATE]: SalaryCertificateApproveForm,
  [RequestTypeCodes.RESUMPTION_REQUEST]: ResumptionRequestApproveForm,
  [RequestTypeCodes.OVERSEAS_MISSION]: OverseasMissionApproveForm,
  [RequestTypeCodes.ATTENDANCE_REQUEST]: AttendanceRequestApproveForm,
};

export default approveFormComponents;
